/* eslint-disable max-len */
/**
 * Italian translations.
 */
export default {
  ACTION: {
    CANCEL: 'Annulla',
    CLOSE: 'Chiudere',
    CONFIRM: 'Conferma',
    CONFIRM_AND_NEXT: 'Conferma e prossimo',
    CONFIRM_AND_SAVE: 'Conferma e salva',
    CREATE: 'Crea',
    DELETE: 'Elimina',
    EDIT: 'Modifica',
    NEW_POST: 'Nuova pubblicazione',
    OK: 'Ok',
    REJECTED: 'Rifiutata',
    REPLY: 'Rispondi',
    SAVE: 'Salva',
    SEND: 'Invia',
    SKIP_CROP: 'Ignora taglio',
    UPDATE: 'Aggiorna',
    UPGRADE: 'Unirsi al club'
  },
  ERROR: {
    FAIL_COPYING_TO_CLIPBOARD: 'Errore durante la copia negli appunti!',
    INSTAGRAM_PUBLISHING_ERROR:
      'Si è verificato un errore durante la condivisione del post su Instagram.',
    INSTAGRAM_PUBLISHING_ERROR_MODAL:
      'Si è verificato un errore durante la condivisione del post su Instagram. Vuoi continuare con la pubblicazione?',
    LINK_ALREADY_EXISTS: 'Link già esistente',
    LINK_VALIDATION_FAILED: 'Impossibile convalidare il link',
    MANDATORY_FIELD: 'Campo obbligatorio',
    MAXIMUM_CHARACTERS: 'Numero massimo di caratteri raggiunto',
    MAXIMUM_FILE_SIZE: 'La dimensione massima consentita è di 100MB!',
    MINIMUM_DIMENSIONS:
      'Il file caricato deve avere dimensioni minime di 480×960',
    PAGE_NOT_APPROVED:
      '❌ Purtroppo, non è stato possibile approvare la tua pagina questa volta. Ma non preoccuparti! ✨\n Puoi modificare il tuo profilo e correggere i campi indicati per inviarlo nuovamente per approvazione.',
    REACTION_LIKE: 'Si è verificato un errore, per favore riprova più tardi!',
    UNSUPPORTED_FORMAT: 'Formato non supportato!',
    VIDEO_CROP: 'Il taglio del video è fallito!'
  },
  HEADER: {},
  LABEL: {
    ACCEPT_TERMS_AND_CONDITIONS: 'Accetto i termini e le condizioni',
    ADDITIONAL_INFORMATION: 'Ulteriori informazioni',
    ADDRESS: 'Indirizzo',
    APPROVED: 'pubblicato',
    ASSETS: 'Immagini o video (dimensione massima 100MB)',
    ASSOCIATE_PRODUCT: 'Associa prodotto Prozis',
    ASSOCIATED_PRODUCTS: 'Prodotti Prozis associati',
    BUSINESS_PAGE: 'Business Page',
    CAPTION: 'Didascalia',
    CHART_BY: 'Grafico per',
    COMMENTS: 'Commenti',
    COMMISSION: 'commissione',
    COMMISSIONS: 'commissioni',
    COMMISSIONS_LAST_30_DAYS: 'ultimi 30 giorni',
    COMPANY_NETWORK: 'Prozis',
    COMPLETED_WITHOUT_DOOR_NUMBER: 'Indirizzo completo senza numero civico',
    CONTINUE_WITH_INSTAGRAM: 'Continua con Instagram',
    COUNTRY: 'Indirizzo solo con paese',
    CREATE_PROFILE: 'Crea profilo',
    CROPPING_ASSET: 'Ritaglia {asset} {ratio}',
    DELETE_POST: 'Elimina pubblicazione?',
    DELETE_POST_ARE_YOU_SURE: 'Sei sicuro di voler eliminare la pubblicazione?',
    DESCRIPTION: 'Biografia',
    DOCUMENT: 'Document',
    DOWNLOAD: 'Scaricare',
    DRAFT_PROFILE: 'Bozza',
    EDIT_PROFILE: 'Modifica pagina',
    ENGAGEMENT: 'Interazione',
    ERROR: 'Errore',
    FEED: 'feed',
    FOLLOWERS: 'Seguaci',
    FRIDAY: 'Friday',
    GALLERY: 'Galleria',
    HIDDEN: 'Non mostra l\'indirizzo',
    IMAGE: 'immagine',
    INSTAGRAM: 'Instagram',
    INSTAGRAM_ACCOUNT: 'Account Instagram',
    LATEST_FIRST: 'Più recenti prima',
    LEAST_PROFITABLE: 'Meno redditizi per primi',
    LIKES: 'Mi piace',
    LIKES_DELETED: 'Mi piace rimossi',
    LINK: 'Collegamento',
    LIVE: 'In diretta',
    LIVES: 'Dirette',
    LOCATION_LEVEL_TYPE_CITY_COUNTRY: 'Indirizzo solo con città e paese',
    LOCATION_LEVEL_TYPE_COMPLETED: 'Indirizzo completo',
    LOCATION_LEVEL_TYPE_COMPLETED_WITHOUT_DOOR_NUMBER:
      'Indirizzo completo senza numero civico',
    LOCATION_LEVEL_TYPE_COUNTRY: 'Indirizzo solo con paese',
    MONDAY: 'Monday',
    MORE: '... Vedi altro',
    MOST_PROFITABLE: 'Più redditizi per primi',
    NAME: 'Nome',
    NEW_FOLLOWERS: 'Nuovi seguaci',
    NEW_POST: 'Nuova pubblicazione',
    NO_PRODUCTS_FOUND: 'Nessun prodotto trovato.',
    NUMBER_OF_FILES: '{file} di {files}',
    OLDEST_FIRST: 'Più vecchie prima',
    ORIGINAL: 'Originale',
    OTHER_NETWORKS: 'Instagram',
    PAGE_PHOTOS: 'Foto di pagina',
    PAST_TIME_DATE: '{value}',
    PAST_TIME_DAYS: '{value} g',
    PAST_TIME_HOURS: '{value} h',
    PAST_TIME_MINUTES: '{value} m',
    PENDING: 'in sospeso',
    POST: 'Pubblicazione',
    POST_COMMENTS: 'Commenti della pubblicazione',
    POST_PRODUCTS: 'Prodotti della pubblicazione',
    POST_VIEWS: 'Visualizzazioni della pubblicazione',
    POSTING_ON_INSTAGRAM: 'Pubblicazione su Instagram',
    POSTS: 'Pubblicazioni',
    PRODUCTS_HASHTAGS: 'Tag dei prodotti',
    PRODUCTS_LINKS: 'Collegamenti ai prodotti',
    PROFESSIONAL_PAGE: 'Pagina Professionale',
    PROFILE: 'Profilo',
    PROFILE_PHOTO: 'Foto del profilo',
    PROFILE_STATUS: 'Stato del profilo',
    PROFILE_VIEWS: 'Visualizzazioni del profilo',
    PROZIS: 'Prozis',
    PROZIS_COMMUNITY: 'Comunità Prozis',
    QUESTION: 'Questione',
    QUESTION_REPLY: 'Rispondi alla questione',
    QUESTIONS: 'Questioni',
    REELS: 'reels',
    REJECTED: 'non pubblicato',
    REJECTED_PROFILE: 'Rifiutato',
    REJECTION_REASON: 'Motivo del rifiuto',
    REPLY: 'Rispondi',
    REQUIRED_FIELDS: 'Campi obbligatori',
    RESET: 'Pulisci',
    SATURDAY: 'Saturday',
    SEARCH: 'Cerca',
    SEARCH_AT_LEAST: 'La parola da cercare deve avere almeno 3 caratteri!',
    SEE_LESS: 'Hide',
    SEE_MORE: 'Vedi di più',
    SEE_ORIGINAL: 'Vedi originale',
    SEE_TRANSLATION: 'Vedi traduzione',
    SHARE_ON_INSTAGRAM: 'Condividi su Instagram',
    SHARE_PROFILE: 'Condividi pagina',
    SOCIAL_NETWORK: 'Rete sociale',
    SOCIAL_NETWORK_COMMISSIONS: 'Commissioni della rete sociale',
    SOCIAL_NETWORK_PAGE: 'Pagina Sociale',
    SOUND: 'Suono',
    SPECIALTIES: 'Specialità',
    STATISTICS_POST: 'Statistiche della pubblicazione',
    STATISTICS_PROFILE: 'Statistiche del profilo',
    STATS_POST_TOTAL: 'Totale commissioni della pubblicazione',
    STATS_POST_TOTAL_COMMENTS: 'Commenti/questioni della pubblicazione',
    STATS_POST_TOTAL_LIKES: 'Mi piace della pubblicazione',
    STATS_POST_TOTAL_PRODUCTS: 'Prodotti associati alla pubblicazione',
    STATS_POST_TOTAL_QUESTIONS: 'Questioni risposte nella pubblicazione',
    STATS_POST_TOTAL_VALUE: 'Valore per la pubblicazione',
    STATS_PROFILE_TOTAL: 'Totale commissioni delle pubblicazioni',
    STATS_PROFILE_TOTAL_COMMENTS: 'Commenti/questioni alle pubblicazioni',
    STATS_PROFILE_TOTAL_FOLLOWERS: 'Nuovi seguaci ottenuti',
    STATS_PROFILE_TOTAL_LIKES: 'Mi piace ottenuti nelle pubblicazioni',
    STATS_PROFILE_TOTAL_POSTS: 'Valore ottenuto nelle pubblicazioni',
    STATS_PROFILE_TOTAL_PRODUCTS: 'Prodotti associati dalle pubblicazioni',
    STATS_PROFILE_TOTAL_QUESTIONS: 'Questioni risposte nelle pubblicazioni',
    STORY: 'storia',
    SUCCESS: 'Successo',
    SUNDAY: 'Sunday',
    TERMS_AND_CONDITIONS: 'Termini e condizioni',
    THURSDAY: 'Thursday',
    TITLE: 'Titolo',
    TOTAL_VIEWS: 'Totale visualizzazioni',
    TUESDAY: 'Tuesday',
    TYPE_OF_DOCUMENT: 'Document type',
    UNFOLLOWERS: 'Non seguaci',
    UNREAD: 'Da leggere',
    UPDATE_POST: 'Aggiorna pubblicazione',
    UPDATED: 'Aggiornato a {date}',
    UPLOAD: 'Carica file',
    UPLOADING_FILES: 'Caricamento file(s)',
    USER_NAME: 'Nome utente',
    VIDEO: 'video',
    VIEW_ALL_COMMENTS: 'Vedi i {total} commenti',
    VIEW_MORE: 'Vedi di più',
    VIEWS: 'Visualizzazioni',
    VISIBILITY_LEVEL: 'Livello di visibilità',
    WAITING_APPROVAL: 'In attesa di approvazione',
    WARNING: 'Avviso',
    WEDNESDAY: 'Wednesday',
    YOUR_PROFILE: 'Il tuo profilo'
  },
  SENTENCE: {
    NO_QUESTIONS_YET: 'Non ci sono ancora questioni.',
    TERMS_AND_CONDITIONS:
      'Interagendo con la "Rete Sociale" di Prozis (a titolo di esempio, commentando e/o condividendo contenuti e reazioni direttamente), l\'Utente dichiara di aver letto, compreso e accettato i seguenti Termini e Condizioni (T & C).\n\nProzis si riserva il diritto di aggiornare i Termini e Condizioni in qualsiasi momento, senza preavviso. Prozis avrà il diritto di operare con tutti i mezzi legali e giusti disponibili.\n\nAccedendo alla "Rete Sociale", l\'Utente dichiara di avere almeno 18 anni e assume la piena responsabilità per le pubblicazioni, commenti, immagini e video inviati ("Contenuti") nella propria "Rete Sociale".\n\nI Contenuti devono appartenere all\'Utente, che dichiara di essere l\'autore e detentore di tutti i diritti di proprietà intellettuale. I Contenuti non devono rappresentare alcuna situazione, edificio o oggetto particolare e/o protetto da diritti d\'autore, marchi registrati o, in generale, loghi di altre aziende, a meno che l\'Utente non abbia ottenuto il consenso necessario per il loro utilizzo.\n\nI Contenuti non devono includere nessun\'altra persona oltre all\'Utente, a meno che il consenso non sia dato dalla stessa persona per iscritto, la cui acquisizione è responsabilità dell\'Utente. L\'Utente terrà indenne Prozis in caso di danni causati dall\'utilizzo di tali immagini e/o video.\n\nUna volta condiviso, il Contenuto diventerà di proprietà esclusiva di Prozis, che sarà autorizzata a pubblicare e/o diffondere e/o utilizzare e/o riprodurre e/o comunicare e/o modificare, con qualsiasi mezzo tecnico e in qualsiasi forma, il suddetto Contenuto, senza esclusione, senza scadenze e senza diritto a compensazioni e/o risarcimenti per le persone coinvolte e/o interessate.\n\nDopo il possibile upload di un contenuto, Prozis si riserva il diritto di rendere visibile solo il materiale che, a suo insindacabile giudizio, non sia dannoso per l\'immagine degli altri, non sia offensivo della morale corrente, o altrimenti lesivo dei diritti degli altri; tendenzioso, diffamatorio, osceno, volgare, calunnioso, razzista, o che costituisca una forma di pubblicità per qualsiasi attività commerciale non inerente al tema proposto o comunque che miri a promuovere marchi, prodotti o servizi diversi da quelli della "Rete Sociale", con contenuti non originali dell\'Utente, ovvero copiati da altre fonti, con contenuti che violano il sistema giuridico italiano, contrariamente alla decenza pubblica, alle normative sulla privacy e, in generale, alla legislazione vigente.\n\nProzis si riserva inoltre il diritto di escludere, prima o dopo la pubblicazione, qualsiasi commento che, a suo esclusivo giudizio, possa essere offensivo, inadeguato e/o incoerente con lo spirito della "Rete Sociale".\n\nProzis si riserva inoltre il diritto, in qualsiasi momento, di rimuovere commenti e/o contenuti pubblicati nella propria "Rete Sociale", indipendentemente o su richiesta di terzi, nonché delle Autorità Giudiziarie, in caso di controversie relative alla legalità o legittimità della suddetta pubblicazione o commento. Solo se il contenuto è considerato idoneo dalla moderazione della "Rete Sociale", sarà lasciato visibile.\n\nDopo il caricamento di un contenuto sulla "Rete Sociale", Prozis si riserva il diritto di caricare o condividere nuovamente, direttamente, i contenuti dell\'Utente sulle proprie piattaforme digitali per promuovere il proprio marchio.',
    WITHOUT_POSTS: 'Non ci sono ancora pubblicazioni.',
    WITHOUT_POSTS_STATISTICS: 'Non ci sono pubblicazioni tra le date scelte.'
  },
  SUCCESS: {
    COPIED_TO_CLIPBOARD: 'Collegamento copiato correttamente negli appunti!',
    CREATED_SUCCESSFULLY: 'Creato con successo!',
    ERROR_PUBLISHING_INSAGRAM: 'Il post è stato pubblicato su Instagram.',
    INSTAGRAM_PUBLISHING_SUCCESS:
      'Il post è stato pubblicato con successo su Instagram.',
    POST_CREATED_SUCCESSFULLY: 'Creata con successo!',
    POST_SAVED_SUCCESSFULLY: 'Aggiornata con successo!',
    POST_SUCCESSFULLY_DELETED: 'Eliminata con successo.',
    SAVED_SUCCESSFULLY: 'Aggiornato con successo!',
    SUCCESSFULLY_DELETED: 'Eliminato con successo.',
    SUCCESSFULLY_REPLIED: 'Risposta con successo.'
  },
  TOOLTIP: {},
  WARNING: {
    ACCPET_TERMS_AND_CONDITIONS:
      'Per favore accetta i termini e le condizioni!',
    EMPTY_PROFILE_IMAGE: 'Devi caricare un\'immagine per il profilo!',
    INVALID_FORM: 'Modulo non valido!'
  }
};
